import { UserReplacementFieldNames } from "@/enums";
import FileSaver from "file-saver";
import _ from "lodash";
import * as XLSX from "xlsx";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

const DEFAULT_COLUMN_CHAR_WIDTH = 16;

const configureWorkSheetColumnsForTable = (workSheet, table) => {
  //SheetJS col width configuration - https://docs.sheetjs.com/docs/csf/features/#row-and-column-properties
  const defaultColConfig = table.headers.map((h) => ({
    wch: DEFAULT_COLUMN_CHAR_WIDTH,
  }));
  workSheet["!cols"] = table.cols ?? defaultColConfig;
  return workSheet;
};

//
const removeObjectFieldsNotInHeaders = (arrayOfObjects, headers) =>
  arrayOfObjects.map((obj) =>
    Object.fromEntries(
      Object.entries(obj).filter((r) => headers.indexOf(r[0]) > -1)
    )
  );

const tableToSheet = (sheet, table) => {
  const exportData = removeObjectFieldsNotInHeaders(table.data, table.headers);
  if (!sheet) {
    sheet = XLSX.utils.json_to_sheet(exportData, {
      header: table.headers,
      skipHeader: false,
      origin: 0,
    });
  } else {
    XLSX.utils.sheet_add_json(sheet, exportData, {
      header: table.headers,
      skipHeader: table.skipHeader,
      origin: -1,
    });
  }

  return configureWorkSheetColumnsForTable(sheet, table);
};

/**
 * @template {{ data: Object[],  headers: string[], skipHeader: bool, cols: Object[] }} table - Table object
 * @param {table[]} tables - Array of table objects
 * @param {string} fileName - Name of downloaded .xlsx file
 * @param {string} sheetName - Name of sheet generated on .xlsx file
 * @param {Object} [workSheet] - Append tables to existing worksheet
 */
export const exportTablesToXLSX = (tables, fileName, sheetName, workSheet) => {
  tables.forEach((table) => {
    var newData = [];
    table.data.forEach((itm) => {
      const keys = Object.keys(itm);
      for (const key in UserReplacementFieldNames) {
        if (keys.includes(_.camelCase(key))) {
          itm[key] = itm[_.camelCase(key)];
          delete itm[_.camelCase(key)];
        } else {
          if (itm.id) {
            itm[key] = "";
          }
        }
      }
      newData.push(itm);
    });
    table.data = newData;
    workSheet = tableToSheet(workSheet, table);
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, workSheet, sheetName ?? "Sheet1");
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName);
};

export const exportWorksheetsToXLSX = (fileName, sheetNames, workSheets) => {
  const workbook = XLSX.utils.book_new();
  let i = 0;
  workSheets.forEach((workSheet) => {
    XLSX.utils.book_append_sheet(
      workbook,
      workSheet,
      sheetNames[i] ?? "Sheet" + i
    );
    i++;
  });
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName);
};

export const buildWorksheetsFromTables = (tables, headers, workSheet) => {
  tables.forEach((table) => {
    var newData = [];
    table.data.forEach((itm) => {
      const keys = Object.keys(itm);
      for (const key in headers) {
        if (keys.includes(_.camelCase(key))) {
          itm[key] = itm[_.camelCase(key)];
          delete itm[_.camelCase(key)];
        } else {
          if (itm.id) {
            itm[key] = "";
          }
        }
      }
      newData.push(itm);
    });
    table.data = newData;
    workSheet = tableToSheet(workSheet, table);
  });
  return workSheet;
};
